import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'
import { Result } from 'antd'
import { InfoCircleOutlined } from '@ant-design/icons'

import Button from 'src/components/Button'

const EmptyRoom = props => {
  return (
    <Result
      status={'404'}
      subTitle={
        <FormattedMessage
          id={'emptyRoom.description'}
          values={{
            br: <br />,
            ul: msg => <ul>{msg}</ul>,
            li: msg => <li>{msg}</li>
          }}
        />
      }
      extra={
        // The help page now lives in this app, so this is a route change and not a trip out
        // through mylm.it and back into a new tab.
        <Link to={'/aiutosale'}>
          <Button icon={<InfoCircleOutlined />}>
            <FormattedMessage id={'emptyRoom.button.faq'} />
          </Button>
        </Link>
      }
    />
  )
}
export default EmptyRoom
